export const generateUniqueId = () => {
  // Use native method if available (all modern browsers)
  if (typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  // Fallback for older browsers
  // based on answer from https://stackoverflow.com/questions/105034/how-do-i-create-a-guid-uuid/2117523#2117523
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = crypto.getRandomValues(new Uint8Array(1))[0];
    const v = c === 'x' ? r & 0xf : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const updateObject = (state, updatedData) => {
  return {
    ...state,
    ...updatedData,
  };
};

export const getQueryStringArray = () => {
  const assoc = getQueryStrings(window.location.search);
  return assoc;
};

export const getSponsorfromPath = () => {
  return getSponsors(window.location.pathname);
};

export const getSponsors = (url) => {
  const patharr = url.split('/');
  if (patharr.length >= 3) return patharr[1];
  else return '';
};

export const getQueryStrings = (url) => {
  const assoc = [];
  const qParams = url.toLowerCase().split('?');
  if (qParams[1] !== undefined) {
    const items = qParams[1].split('&');
    for (let j = 0; j < items.length; j++) {
      const a = items[j].split('=');
      assoc[a[0]] = a[1];
    }
  }
  return assoc;
};

function convertToPascalCase(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function convertObjectKeysToPascalCase(obj) {
  if (Array.isArray(obj)) {
    return obj.map((item) => convertObjectKeysToPascalCase(item));
  }

  if (typeof obj === 'object' && obj !== null) {
    return Object.keys(obj).reduce((acc, key) => {
      const pascalCaseKey = convertToPascalCase(key);
      acc[pascalCaseKey] = convertObjectKeysToPascalCase(obj[key]);
      return acc;
    }, {});
  }
  return obj;
}
